module.exports = __webpack_public_path__ + "img/018-lebanon.cd47c8f4.svg";